import { Alert, AlertTitle, Slide, Snackbar } from '@mui/material'
import { t } from 'i18next'

import Show from '../../Layout/Can/Show.jsx'
import { useGlobalContext } from '../Contexts/GlobalContext.jsx'

const SuccessAlert = () => {
  const { successAlert: isOpen, setSuccessAlert, successAlertMessage } = useGlobalContext()

  return (
    <Show when={() => isOpen}>
      <Snackbar
        open={isOpen}
        onClose={() => setSuccessAlert(false)}
        autoHideDuration={5000}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        TransitionComponent={(props) => (
          <Slide
            {...props}
            direction="down"
          />
        )}
        sx={{
          width: '20%'
        }}>
        <Alert
          severity="success"
          sx={{
            width: '100%'
          }}>
          <AlertTitle>{t('common.operationCompleted')}</AlertTitle>
          {successAlertMessage || t('common.operationCompletedSuccessfully')}
        </Alert>
      </Snackbar>
    </Show>
  )
}

export default SuccessAlert
